import skrollTop from 'skrollTop';
import {getOffset} from './_getOffset';

export function viewerVertical() {
  const closestGreaterOrEqual = (arr, target) => {
    return arr.reduce((closest, num) => {
      if (num >= target) {
        return (Math.abs(closest - target) > Math.abs(num - target)) ? num : closest;
      }
      return closest;
    }, Infinity);
  }
  const closestLessOrEqual = (arr, target) => {
    return arr.reduce((closest, num) => {
      if (num <= target) {
        return (Math.abs(closest - target) > Math.abs(num - target)) ? num : closest;
      }
      return closest;
    }, -Infinity);
  }

  const viewers = document.querySelectorAll(".viewer-vertical");
  const identity = document.querySelector('.identity')
  if(viewers.length) {
    viewers.forEach((viewer, i) => {
      const viewerid = viewer.dataset.viewer;
      const boxes = viewer.querySelectorAll(".slide");
      const horizontalBoxes = viewer.querySelectorAll(".slide-horizontal");
      const pageNumber = document.querySelectorAll(`.slide-counter[data-viewer="${viewerid}"]`);
      const prevButton = document.querySelectorAll(`.slide-prev[data-viewer="${viewerid}"]`);
      const nextButton = document.querySelectorAll(`.slide-next[data-viewer="${viewerid}"]`);
      const totalBoxes = boxes.length;
      let viewerOffsetTop = 0;
      let viewerOffsetBottom = 0;
      let currentBox = 0;
      let boxPosArr = [];
      let scrollPosArr = [];

      if (horizontalBoxes.length) {
        horizontalBoxes.forEach((box, i) => {
          box.classList.remove("box-overflow");
          const img = box.querySelector("img");
          let isReverse = false;
          if(box.classList.contains('is-reverse')) {
            isReverse = true;
          }

          let ww = ``;
          let wh = ``;
          let w = ``;
          let h = ``;
          let imgw = ``;
          let imgh = ``;
          let offset = ``;
          let offsetTop = ``;
          let offsetBottom = ``;
          let gap = ``;

          const setHorizontalSize = () => {
            box.style.height = ``;
            ww = window.innerWidth;
            wh = window.innerHeight;
            w = box.clientWidth;
            h = box.clientHeight;
            imgw = img.clientWidth;
            imgh = img.clientHeight;
            if (ww < imgw) {
              box.classList.add('horizontal-scrolling');
              gap = imgw - ww;
              box.style.height = `${h + gap * 2}px`;
              h = box.clientHeight;
              offset = getOffset(box);
              offsetTop = offset.top;
              offsetBottom = offsetTop + h;
              box.setAttribute('data-bottom', offsetTop + gap*2);
            } else {
              box.classList.remove('horizontal-scrolling');
              box.setAttribute('data-bottom', "");
            }
          };

          const horizontalView = () => {
            if(box.classList.contains('horizontal-scrolling')) {
              const scTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
              const scBottom = scTop + wh;
              if (scTop >= offsetTop) {
                if (scBottom >= offsetBottom) {
                  img.style.position = `absolute`;
                  img.style.top = ``;
                  img.style.bottom = `0`;
                  if(isReverse) {
                    img.style.right = `0`;
                    img.style.transform = `translateX(${gap}px)`;
                  } else {
                    img.style.left = `0`;
                    img.style.transform = `translateX(-${gap}px)`;
                  }
                } else {
                  img.style.position = `fixed`;
                  img.style.top = `0`;
                  img.style.bottom = ``;
                  if(isReverse) {
                    img.style.right = `0`;
                    const horizontal = (scTop - offsetTop) / 2;
                    img.style.transform = `translateX(${horizontal}px)`;
                  } else {
                    img.style.left = `0`;
                    const horizontal = (scTop - offsetTop) / 2;
                    img.style.transform = `translateX(-${horizontal}px)`;
                  }
                }
              } else {
                img.style.position = ``;
                img.style.top = ``;
                img.style.bottom = ``;
                if(isReverse) {
                  img.style.right = ``;
                } else {
                  img.style.left = ``;
                }
                img.style.transform = ``;
              }
            } else {
              img.style.position = ``;
              img.style.top = ``;
              img.style.bottom = ``;
              if(isReverse) {
                img.style.right = ``;
              } else {
                img.style.left = ``;
              }
              img.style.transform = ``;
            }
          };
      
          let lastInnerWidth = window.innerWidth;
          window.addEventListener("resize", () => {
            if (lastInnerWidth != window.innerWidth) {
              setHorizontalSize();
              horizontalView();
              lastInnerWidth = window.innerWidth;
            }
          });

          window.addEventListener("scroll", horizontalView);
          window.addEventListener("load", () => {
            setPos();
            checkScrollTopPos();
          });
          setHorizontalSize();
          horizontalView();
        });
      }

      const setPos = () => {
        boxPosArr = [];
        scrollPosArr = [];
        const beforeStr = getComputedStyle(viewer, ":before").content;
        // console.log(beforeStr);
        let headerHeight = 0;
        if(identity && beforeStr == '"sp"') {
          headerHeight = identity.offsetHeight
        }
        boxes.forEach((box, i) => {
          const boxScrollOffset = getOffset(box);
          let boxScrollTop = boxScrollOffset.top
          boxScrollTop = boxScrollOffset.top - headerHeight;
          const boxScrollBottom = boxScrollTop + box.offsetHeight;
          boxPosArr.push([boxScrollTop, boxScrollBottom]);
          scrollPosArr.push(boxScrollTop);
          if(box.classList.contains('horizontal-scrolling')) {
            scrollPosArr.push(Number(box.dataset.bottom));
          }
        })
        const viewerOffset = getOffset(viewer);
        viewerOffsetTop = viewerOffset.top;
        const viewerHeight = viewer.offsetHeight;
        viewerOffsetBottom = viewerOffsetTop + viewerHeight;
      }

      const checkScrollTopPos = function() {
        const scTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
        const scBottom = scTop + window.innerHeight;

        // Check if viewer-vertical bottom is above window bottom
        if (viewerOffsetBottom < scBottom) {
          document.body.classList.add('is-vertical-viewer-bottom-end');
        } else {
          document.body.classList.remove('is-vertical-viewer-bottom-end');
        }

        boxPosArr.forEach((arr, i) => {
          const thisScrollTop = arr[0];
          const thisScrollBottom = arr[1];
          if(thisScrollTop < scTop && thisScrollBottom > scTop) {
            currentBox = i;
          }
          if (pageNumber.length) {
            pageNumber.forEach((number, i) => {
              number.textContent = `${currentBox + 1}/${totalBoxes}`;
            });
          }
        })
      }

      const goToPage = (dir) => {
        const scTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
        const dur = 600;
        if(dir == 'prev') {
          let top = closestLessOrEqual(scrollPosArr, scTop - 1);
          if(top == -Infinity) {
            top = viewerOffsetTop
          }
          document.body.classList.remove('is-disable-scroll-direction');
          skrollTop.scrollTo({
            to: top,
            duration: dur,
            callback: function() {}
          });
        } else if(dir == 'next') {
          let top = closestGreaterOrEqual(scrollPosArr, scTop + 1);
          if(top == Infinity) {
            top = viewerOffsetBottom;
          }
          document.body.classList.add('is-disable-scroll-direction');
          skrollTop.scrollTo({
            to: top,
            duration: dur,
            callback: function() {
              document.body.classList.add('dir-bottom');
            }
          });
          setTimeout(() => {
            document.body.classList.remove('is-disable-scroll-direction');
          }, dur+300)
        }
      }

      if (prevButton.length) {
        prevButton.forEach((button, i) => {
          button.addEventListener("click", (e) => {
            e.preventDefault();
            if(!document.body.classList.contains('is-disable-scroll-direction')) {
              goToPage('prev')
            }
          });
        });
      }

      if (nextButton.length) {
        nextButton.forEach((button, i) => {
          button.addEventListener("click", (e) => {
            e.preventDefault();
            if(!document.body.classList.contains('is-disable-scroll-direction')) {
              goToPage('next')
            }
          });
        });
      }

      document.addEventListener("keydown", (e) => {
        if (e.key === "ArrowUp") {
          e.preventDefault();
          if(!document.body.classList.contains('is-disable-scroll-direction')) {
            goToPage('prev');
          }
        } else if (e.key === "ArrowDown" || e.key === " ") {
          e.preventDefault();
          if(!document.body.classList.contains('is-disable-scroll-direction')) {
            goToPage('next');
          }
        }
      })

      let scrollTimeout;
      window.addEventListener("scroll", () => {
        checkScrollTopPos();
      });

      let lastInnerWidth = window.innerWidth;
      window.addEventListener("resize", () => {
        if (lastInnerWidth != window.innerWidth) {
          setPos();
          checkScrollTopPos();
          lastInnerWidth = window.innerWidth;
        }
      });

      window.addEventListener("load", () => {
        setPos();
        checkScrollTopPos();
      });

      setPos();
      checkScrollTopPos();
    });
  }
}